import { BarChart } from '@mui/icons-material';
import { useCallback } from 'react';
import { Button } from '~/components/Button';
import useRouter from '~/hooks/useRouter';
import { cleanReportName } from '~/scripts/cleanReportName';

interface ViewOverlapButtonProps {
  searches_uuid: string;
  name: string;
}
export default function ViewOverlapButton({
  searches_uuid,
  name,
}: ViewOverlapButtonProps) {
  const router = useRouter();
  // don't want google clicking these links
  // so making it an onclick instead
  const callback = useCallback(() => {
    router.push({
      path: `/overlap/${cleanReportName(name || '_')}/${searches_uuid}`,
    });
  }, [router, searches_uuid, name]);
  return (
    <Button
      onClick={callback}
      startIcon={<BarChart />}
      data-fullstory="view overlaps">
      View Overlaps
    </Button>
  );
}
